import { render, staticRenderFns } from "./commit_list_app.vue?vue&type=template&id=08b8df86"
import script from "./commit_list_app.vue?vue&type=script&lang=js"
export * from "./commit_list_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports